import { MealType } from '@akin-home/amplify';
import { isValidTimeFormat } from '@akin-home/dates';
import { default_meal_times } from '../data';

export const getMealTime =
  (meal_type: MealType) => (meal_times?: Partial<Record<MealType, string>>) => {
    const time = meal_times?.[meal_type];

    return isValidTimeFormat(time) ? time : default_meal_times[meal_type];
  };

export const getBreakfastTime = getMealTime(MealType.Breakfast);
export const getLunchTime = getMealTime(MealType.Lunch);
export const getDinnerTime = getMealTime(MealType.Dinner);
export const getSnackTime = getMealTime(MealType.Snack);
